import React, { Component } from "react";

class UserItemWebinar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    };
  }
  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { id, full_name, email, first_name, last_name } = this.props.user;

    const ITEM_HEIGHT = 48;

    const is_checked = _.includes(this.props.user_ids.map(Number), id);
    const { anchorEl } = this.state;

    return (
      <tr>
        <td>
          <p>
            <input
              type="checkbox"
              className="filled-in"
              id="filled-in-box10"
              key={id}
              checked={is_checked}
            />
            <label
              for="filled-in-box10"
              onClick={() => this.props.checkedUserIds(id, email)}
            ></label>
          </p>
        </td>
        <td>{full_name || `${first_name} ${last_name}`}</td>
        <td>{email}</td>
      </tr>
    );
  }
}

UserItemWebinar.defaultProps = {};

UserItemWebinar.propTypes = {};

export default UserItemWebinar;



// WEBPACK FOOTER //
// ./src/components/AddUsersWebinar/UserItemWebinar.jsx